/** Control an automation field is rendered with, as the api numbers it. */
export enum AutomationFieldType {
    SingleSelect = 0,
    MultiSelect = 1,
    FreeText = 2,
    Number = 3,
    Date = 4,
    Integer = 5,
}

/**
 * What the value of an option of a field means, and therefore what a rule
 * stores for it.
 *
 * A name is the text of the option, which the same repository field can offer
 * in several repositories, so a rule expressed in names applies to all of them.
 * An id belongs to a single record, so it is only ever the value of fields
 * whose records are shared, such as a station or a fixer.
 */
export enum AutomationValueKind {
    Id = 'Id',
    Name = 'Name',
}

/**
 * Option of an automation field. The value is a string for both value kinds,
 * so an id is `'1001'` and a name is the text of the option itself.
 */
export interface AutomationFieldOption {
    backingField: string;
    displayName: string;
}

export interface AutomationField {
    fieldId: number;
    fieldName: string;
    fieldType: number;
    options?: AutomationFieldOption[];
    /** `null` for a field the api holds no options for. */
    valueKind?: AutomationValueKind | null;
}

export interface AutomationRuleType {
    id: number;
    inputFields: AutomationField[];
    outputFields: AutomationField[];
}

export interface CreateAutomationRuleTypeRequest {
    inputFieldIds: number[];
    outputFieldIds: number[];
}
